// src/components/ProcessDialog/MobileResults.jsx
import React from 'react';
import {
    Stack,
    Typography,
    Card,
    Box,
    Skeleton,
    Divider,
    useTheme,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ShieldCheck } from 'lucide-react';
import { PiTestTubeDuotone } from 'react-icons/pi';
import MobileResultCard from './MobileResultCard';

/** `secoes`: ver DesktopResults (utils/predicao secoesDoResultado). */
const MobileResults = ({ isPresenceMode, hasPresenceData, isSubmitting, secoes = [] }) => {
    const theme = useTheme();

    const renderPresenceCard = (key, title, presence, agua) => {
        const isPending = presence === undefined || isSubmitting;
        const isPresenca = presence === true;

        let iconPanelBg = alpha(theme.palette.text.primary, 0.04);
        let iconColor = alpha(theme.palette.text.primary, 0.3);
        let cardBg = 'background.paper';

        if (!isPending) {
            if (isPresenca) {
                iconPanelBg = alpha(theme.palette.error.main, 0.06);
                iconColor = theme.palette.error.main;
                cardBg = alpha(theme.palette.error.main, 0.06);
            } else {
                iconPanelBg = alpha(theme.palette.success.main, 0.06);
                iconColor = theme.palette.success.main;
                cardBg = alpha(theme.palette.success.main, 0.06);
            }
        }

        return (
            <Card
                key={key}
                elevation={0}
                sx={{
                    borderRadius: 3,
                    border: '1px solid',
                    borderColor: isPending
                        ? 'divider'
                        : isPresenca
                          ? alpha(theme.palette.error.main, 0.3)
                          : alpha(theme.palette.success.main, 0.3),
                    bgcolor: cardBg,
                    overflow: 'hidden', // Importante para o painel lateral
                }}
            >
                {/* ESTRUTURA ATUALIZADA PARA PAINEL LATERAL RETANGULAR IGUAL AO DESKTOP */}
                <Stack direction="row" sx={{ height: '100%' }}>
                    {/* O PAINEL LATERAL RETANGULAR DO ÍCONE */}
                    <Box
                        sx={{
                            width: 60, // Largura do painel lateral
                            bgcolor: iconPanelBg,
                            borderRight: '1px solid',
                            borderColor: 'divider',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <PiTestTubeDuotone
                            size={24}
                            color={iconColor}
                            strokeWidth={2.5}
                        />
                    </Box>

                    {/* CONTEÚDO DO CARTÃO (TÍTULO, RESULTADO, PORTARIA) */}
                    <Box sx={{ flexGrow: 1, p: 2 }}>
                        <Typography
                            variant="caption"
                            color="text.secondary"
                            fontWeight={700}
                            display="block"
                            sx={{
                                textTransform: 'uppercase',
                                letterSpacing: 0.5,
                            }}
                        >
                            {title}
                        </Typography>
                        {isPending ? (
                            <Skeleton variant="text" width={100} height={32} />
                        ) : (
                            <Typography
                                variant="h6"
                                fontWeight={800}
                                color={isPresenca ? 'error.main' : 'success.main'}
                                lineHeight={1.2}
                            >
                                {isPresenca ? 'PRESENÇA' : 'AUSÊNCIA'}
                                {agua && (
                                    <Typography
                                        component="span"
                                        variant="body2"
                                        fontWeight={700}
                                        sx={{ ml: 0.5, opacity: 0.8 }}
                                    >
                                        em 100 mL
                                    </Typography>
                                )}
                            </Typography>
                        )}

                        {!isPending && agua && (
                            <Box sx={{ mt: 1.5 }}>
                                <Divider sx={{ mb: 1, opacity: 0.6 }} />
                                <Stack spacing={0.5}>
                                    <Stack
                                        direction="row"
                                        spacing={0.5}
                                        alignItems="center"
                                    >
                                        <ShieldCheck
                                            size={14}
                                            color={theme.palette.text.secondary}
                                        />
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{ fontSize: '0.65rem' }}
                                        >
                                            Padrão Portaria 888:{' '}
                                            {isPresenca
                                                ? 'Presença em 100 mL'
                                                : 'Ausência em 100 mL'}
                                        </Typography>
                                    </Stack>
                                    <Typography
                                        variant="caption"
                                        fontWeight={800}
                                        color={
                                            isPresenca
                                                ? 'error.main'
                                                : 'success.main'
                                        }
                                        sx={{ fontSize: '0.7rem' }}
                                    >
                                        STATUS:{' '}
                                        {isPresenca
                                            ? 'NÃO CONFORME'
                                            : 'CONFORME'}
                                    </Typography>
                                </Stack>
                            </Box>
                        )}
                    </Box>
                </Stack>
            </Card>
        );
    };

    if (isPresenceMode) {
        return (
            <Stack spacing={1.5}>
                {secoes.map((s) => renderPresenceCard(s.chave, s.titulo, s.presenca, s.agua))}
            </Stack>
        );
    }

    return (
        <Stack spacing={2}>
            {secoes.map((s) => (
                <MobileResultCard
                    key={s.chave}
                    title={s.titulo}
                    presence={s.presenca}
                    unidade={s.unidade}
                    agua={s.agua}
                    labNmp={s.labLog}
                    predNmp={s.predLog}
                    submitting={isSubmitting}
                    hasPresenceData={hasPresenceData}
                />
            ))}
        </Stack>
    );
};

export default MobileResults;
